import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import { ExpandMore, ExpandLess } from '@mui/icons-material';

import Second from './Second';

class App extends React.Component {
  state={ more: false, height: '0px', maxHeight: 0, over: false }
  _clickMoreBtn=() => {
    this.setState({ more: !this.state.more });
    const { more } = this.state;
    if (more) {
      clearInterval(this.timer);
      this.setState({ height: '0px', maxHeight: 0 });
    } else {
      this.timer = setInterval(() => {
        const { maxHeight } = this.state;
        if (maxHeight < 10000) this.setState({ height: 'auto', maxHeight: maxHeight + 5 });
        else clearInterval(this.timer);
      }, 5);
    }
  }

  render () {
    const { data } = this.props;
    const { more, height, maxHeight, over } = this.state;
    return (
      <div>
        <div style={{ display: 'flex', paddingBottom: 8, paddingTop: 8, paddingRight: 8, paddingLeft: 12, cursor: 'pointer', backgroundColor: over ? '#a8a8a8' : 'transparent' }} onClick={this._clickMoreBtn} onMouseOver={() => this.setState({ over: true })} onMouseOut={() => this.setState({ over: false })}>
          <data.icon style={{ color: '#064B6F', height: 24, width: 24 }} />
          <div style={{ flex: 1 }}>
            <div style={{ width: '100%', fontSize: 16, lineHeight: '24px', letterSpacing: '0.15%', marginLeft: 10, textAlign: 'start' }}>{data.text}</div>
          </div>
          <div style={{ height: 24, display: 'flex', alignItems: 'center' }}>
            {!more && <ExpandMore style={{ color: '#064B6F', height: 18, width: 18 }} />}
            {more && <ExpandLess style={{ color: '#064B6F', height: 18, width: 18 }} />}
          </div>
        </div>
        <div style={{ height: 1, backgroundColor: '#979797' }} />
        <div style={{ width: '100%', height, maxHeight, overflow: 'hidden' }}>
          {data.detail.map((o, i) => <Second key={o.text} data={o} firstPath={data.path} />)}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  pathAry: state.data.PathAry,
});
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
